document.addEventListener('DOMContentLoaded', function () {
  var button = document.querySelector('.gs-launch .menu-toggle');
  var menu = document.querySelector('.gs-launch #gs-menu');

  if (button && menu) {
    var closeMenu = function () {
      button.setAttribute('aria-expanded', 'false');
      menu.removeAttribute('data-open');
    };

    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      if (open) menu.removeAttribute('data-open');
      else menu.setAttribute('data-open', 'true');
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) closeMenu();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1000) closeMenu();
    });
  }

  var order = document.querySelector('[data-quick-order]');
  if (order) {
    var orderForm = order.querySelector('form');
    var orderLines = Array.from(order.querySelectorAll('[data-order-line]'));
    var orderMoney = function (pence) {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(pence / 100);
    };
    var orderUpdate = function () {
      var count = 0;
      var net = 0;
      var list = [];
      orderLines.forEach(function (line) {
        var input = line.querySelector('[data-order-qty]');
        var amount = Math.max(0, Math.min(100000, Math.floor(Number(input.value) || 0)));
        var packSize = Number(line.querySelector('[data-order-pack]').value);
        var factor = packSize === 100 ? 1 : packSize === 50 ? 1 + Number(order.dataset.mediumUplift) / 100 : 1 + Number(order.dataset.smallUplift) / 100;
        var price = Math.round(Number(line.dataset.price) * factor);
        var screws = amount * packSize;
        count += screws;
        net += screws * price;
        line.querySelector('[data-order-qty-label]').textContent = packSize === 1 ? 'Singles' : 'Cages';
        line.querySelector('[data-order-unit]').textContent = orderMoney(price) + ' ex VAT / screw';
        line.querySelector('[data-order-unit-gross]').textContent = orderMoney(Math.round(price * 1.2)) + ' inc VAT';
        if (amount > 0) list.push(line.dataset.title + ': ' + amount + (packSize === 1 ? ' singles' : ' cages of ' + packSize) + ' (' + screws + ' screws) at ' + orderMoney(price) + ' ex VAT per screw');
      });
      var vat = Math.round(net * 0.2);
      order.querySelector('[data-order-count]').textContent = String(count);
      order.querySelector('[data-order-net]').textContent = orderMoney(net);
      order.querySelector('[data-order-vat]').textContent = orderMoney(vat);
      order.querySelector('[data-order-gross]').textContent = orderMoney(net + vat);
      order.querySelector('[data-order-message]').value = list.join('\n') + '\nScrew guide subtotal ex VAT: ' + orderMoney(net) + '\nVAT at 20%: ' + orderMoney(vat) + '\nScrew guide subtotal inc VAT: ' + orderMoney(net + vat) + '\nPlease confirm stock, delivered price, lead time, components and volume pricing. No order placed.';
      order.querySelector('[data-order-status]').textContent = count > 0 ? count + ' screws selected. Send your list for stock and delivered pricing.' : 'Add quantities to prepare your enquiry.';
      return count;
    };
    order.querySelectorAll('[data-order-qty]').forEach(function (input) {
      input.addEventListener('input', orderUpdate);
    });
    order.querySelectorAll('[data-order-pack]').forEach(function (select) {
      select.addEventListener('change', orderUpdate);
    });
    var requestedProduct = new URLSearchParams(window.location.search).get('gs_product');
    if (requestedProduct) {
      orderLines.forEach(function (line) {
        var link = line.querySelector('.quick-order-image');
        if (link && link.getAttribute('href').split('/').pop() === requestedProduct) line.querySelector('[data-order-qty]').value = '1';
      });
    }
    orderForm.addEventListener('submit', function (event) {
      if (orderUpdate() === 0) {
        event.preventDefault();
        order.querySelector('[data-order-status]').textContent = 'Enter a quantity for at least one screw length before sending.';
        order.querySelector('[data-order-qty]').focus();
      }
    });
    orderUpdate();
  }

  var root = document.querySelector('[data-calc]');
  if (!root) return;
  var size = root.querySelector('#calc-size');
  var qty = root.querySelector('#calc-qty');
  var tier = root.querySelector('#calc-tier');
  var total = root.querySelector('#calc-total');
  var unit = root.querySelector('#calc-unit');
  var saving = root.querySelector('#calc-saving');
  var prices = {
    standard: [16.5, 18.5, 23.5, 28.5],
    first: [14, 15, 18, 21],
    next: [15, 16, 19, 22],
    final: [16, 17, 20, 23]
  };
  var money = function (value) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
  };
  var update = function () {
    var cages = Math.max(1, Math.floor(Number(qty.value) || 1));
    var amount = cages * 100;
    var index = Number(size.value);
    var price = prices[tier.value][index];
    total.textContent = money(amount * price);
    unit.textContent = money(price) + ' per screw · ex VAT & delivery';
    saving.textContent = tier.value === 'standard' ? '' : money((prices.standard[index] - price) * amount) + ' indicative saving vs standard trade';
  };
  size.addEventListener('change', update);
  qty.addEventListener('input', update);
  tier.addEventListener('change', update);
  update();
});
